/**
 * Auth Token Provider Interface
 *
 * This abstraction isolates the API client from the specific auth implementation (Firebase).
 * The actual token provider is set at app initialization, following the port-adapter pattern.
 *
 * Why this exists:
 * - Firebase SDK should only be used within features/auth/
 * - shared/api/ should not know about Firebase
 * - This allows for easy testing with mock token providers
 */

export interface AuthTokenProvider {
  getToken(): Promise<string | null>;
}

let tokenProvider: AuthTokenProvider | null = null;

export function setAuthTokenProvider(provider: AuthTokenProvider): void {
  tokenProvider = provider;
}

export function getAuthTokenProvider(): AuthTokenProvider | null {
  return tokenProvider;
}
